import {lib_en_US} from '@docupet/component-library';
import en_US from '@/translations/en-US';

export default {
    ...lib_en_US,
    ...en_US,
};
